import brand1 from "../../assets/brands/brand1.png";
import brand2 from "../../assets/brands/brand2.png";
import brand3 from "../../assets/brands/brand3.png";
import brand5 from "../../assets/brands/brand5.png";

// original 4 brands
const baseBrands = [
    { image: brand1, alt: "Brand 1" },
    { image: brand2, alt: "Brand 2" },
    { image: brand3, alt: "Brand 3" },
    { image: brand5, alt: "Brand 5" },
];

export const trustedByBrandsContent = {
    title: "Trusted By Brands",

    brands: [...baseBrands, ...baseBrands, ...baseBrands],

    sliderSettings: {
        dots: false,
        arrows: false,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 2000,
        speed: 600,
        cssEase: "ease",

        slidesToShow: 4,
        slidesToScroll: 1,
        pauseOnHover: false,

        responsive: [
            { breakpoint: 1024, settings: { slidesToShow: 3 } },
            { breakpoint: 768, settings: { slidesToShow: 2 } },
            { breakpoint: 480, settings: { slidesToShow: 1 } },
        ],
    },
};